import { useLocation, useNavigate } from "react-router";
import { COMMON_ALT, COMMON_WEB_PATH } from "../../constant";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Flex,
  Icon,
  Image,
  Text,
  useBreakpointValue,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import useCheckLogin from "../../hook/useCheckLogin";
import HeaderAppDownload from "../../pages/App/HeaderAppDownload";
import Balance from "../Balance/Balance";
import { LANGUAGES_MENU } from "../../i18n/config";
import MarqueeList from "../marquee/MarqueeList";
import { machineLogin } from "../../api/getApi";
import ClearCashRegisterButton from "../ClearCash/ClearCashRegisterButton";
import MusicToggleButton from "./HeaderComponents/MusicToggleButton";
import ReloadButton from "./HeaderComponents/ReloadButton";
import { MdOutlineLanguage } from "react-icons/md";
import { openLanguagePop } from "../../redux/action/member/memberAction";
import LanguageButton from "./HeaderComponents/languageButton";
import BetRecordButton from "../BetRecordButton/BetRecordButton";
import useIsLandScapeMachine from "../../hook/useIsLandScapeMachine";
import useLongMachineSetting from "../../hook/useLongMachineSetting";
import useDomainConfig from "../../hook/useDomainConfig";
import AnnouncementButton from "./HeaderComponents/AnnouncementButton";
import GameSearch from "./HeaderComponents/GameSearch";

const isCredit = process.env.REACT_APP_CREDIT == 1;

const Header = () => {
  const { t, i18n } = useTranslation();
  //const i18n = (key) => t(`common.${key}`);
  const i18n_header = (key) => t(`header.${key}`);
  const i18n_common = (key) => t(`common.${key}`);
  const i18n_profile = (key) => t(`profile.${key}`);

  const iconBg = useColorModeValue("#E9E8F2", "#262D47");
  // 取 登入狀態 機台相關的狀態
  const { isLogin, isMachineDomain, isMachineUser } = useCheckLogin();

  const { animationLogoUrl } = useDomainConfig();

  const memberInfo = useSelector((state) => state.isMemberInfo);

  const location = useLocation(); //返回一個location對象，其中包含當前URL的信息。它與window.location最大的區別是，它不會引起頁面重新加載。你可以在任何地方使用它，包括React Hooks組件中。

  const dispatch = useDispatch();

  const isMachineLandscape = useIsLandScapeMachine();

  const { longMachineVideoHeight } = useLongMachineSetting();

  const profilePath = useBreakpointValue({
    base: "profile",
    sm: "profile/data",
  });

  const gradientStyle = {
    color: "white",
    WebkitTextStroke: "1px #804ed2",
    textStroke: "1px #804ed2",
    textShadow: `
    -1px -1px 0 #804ed2,  
     1px -1px 0 #804ed2,
    -1px 1px 0 #804ed2,
     1px 1px 0 #804ed2
  `,

    display: "inline-block",
  };

  return (
    <Box
      width={{
        base: `100%`,
        xl: `100%`,
      }}
      minHeight={{
        sm: "45px",
        base: "45px",
        xl: "90px",
      }}
      position="fixed"
      //flexDirection={"column"}
      mx="auto"
      top={isMachineLandscape ? longMachineVideoHeight : "0px"}
      // left="0px"
      // bg={headerBg}
      bg={{
        base: `rgba(0,0,0,0.9)`,
        xl: `none`,
      }}
      // bgImage={`url('${COMMON_WEB_PATH}/FlyDragon/titleBG5.webp')`}
      bgPosition="center"
      bgRepeat="no-repeat"
      bgSize="100%100%"
      //zIndex="1001"
      zIndex={{
        base: "999",
        sm: "1001",
      }}
      display="flex"
      alignItems={isMachineUser ? "flex-start" : "center"}
      justifyContent="space-between"
      // borderColor={headerBorder}
      px={{
        base: "2%",
        md: "2%",
        lg: "2%",
        xl: "2%",
      }}
      borderBottom={{
        base: "2px solid #e5c1f5", // 更亮紫色底線
        lg: "none",
      }}
      boxShadow={{
        base: "0 0 0.1em #ead8f2, 0 0 0.1em #ead8f2", // 光晕
        lg: "none",
      }}
      transition="all 0.3s ease" // 過渡
    >
      <HeaderAppDownload />

      <Flex
        // position="absolute"
        // left="0px"
        // top="0%"
        /* logo 雖然有指定寬高,但 flex item 預設 flex-shrink:1,
           而裡面的 Image 是 width/height 100%(min-content 為 0),
           所以跑馬燈一長就會被一路壓到寬度 0、整個 logo 消失。
           固定不縮,讓跑馬燈自己去吸收空間不足。 */
        flexShrink={0}
        w={{
          base: isLogin ? "80px" : "150px",
          sm: isLogin ? "150px" : "150px",
          md: isLogin ? "300px" : "220px",
          //xl: isLogin ? "300px" : "220px",
          xl: isLogin
            ? isMachineUser
              ? "300px"
              : "300px"
            : isMachineUser
              ? "280px"
              : "220px", // 根據是否為機台用戶調整寬度
        }}
        h={{
          base: isLogin ? "45px" : "45px",
          sm: isLogin ? "90px" : "90px",
          // md: isLogin ? "100px" : "100px",
          // xl: isLogin ? "100px" : "100px",
          xl: isMachineUser ? "150px" : "100px", // 根據是否為機台用戶調整高度
        }}
        // bgImage={`url('${COMMON_WEB_PATH}/FlyDragon/headerLeft.webp')`}
        // bgPosition="center"
        // bgRepeat="no-repeat"
        // bgSize="100% 100%"
        zIndex="1002"
        sx={{
          // 用 sx屬性加上自定義 CSS
          filter: "drop-shadow(0px 0px 10px rgba(0,0,0,0.5))",
        }}
      >
        <Flex
          // display={{
          //   base: "block",
          //   lg: isGameBox ? "block" : "none",
          // }}
          alignItems={`center`}
          color="light.100"
          justifyContent="center"
        >
          <Flex
            alignItems={"center"}
            gap="30px"
            justifyContent={{
              base: "flex-start",
              sm: "center",
            }}
          >
            <Link to="/">
              <Image //用三元運算 (? :) 去判斷 如果已登入就顯示 stylesConfig.loggedInLogo 圖片，否則顯示 stylesConfig.mainLogo 圖片
                src={animationLogoUrl}
                cursor={"pointer"}
                mr={{
                  base: "0px",
                  lg: "0px",
                }}
                ml={{
                  base: "0px",
                  lg: "0px",
                }}
                // mt={{
                //   base: "5px",
                //   lg: "5px",
                // }}
                height={"100%"}
                maxH={{
                  base: isLogin ? "100%" : "40px",
                  lg: "85px",
                  //xl: "85px",
                  xl: isMachineUser ? "150px" : "85px",
                }}
                width={"100%"}
                maxW={{
                  base: "70px",
                  sm: "120px",
                  md: "135px",
                  lg: "165px",
                  //xl: "185px",
                  xl: isMachineUser ? "280px" : "185px",
                }}
                sx={{
                  "@media screen and (min-width: 1536px)": {
                    maxWidth: "205px",
                  },
                  "@media screen and (min-width: 1920px)": {
                    maxWidth: "225px",
                  },
                }}
                pointerEvents="all"
                alt={COMMON_ALT}
              />
            </Link>
          </Flex>
        </Flex>
      </Flex>

      <Flex
        alignItems={`center`}
        justifyContent={{
          base: "flex-end",
          sm: "space-between",
        }}
        pl={{
          md: "0px",
          base: "0px",
        }}
        pr={{
          md: "0px",
          base: "0px",
        }}
        pt={{
          base: "0px",
          sm: "0px",
        }}
        pb={{
          base: "0px",
          sm: "0px",
        }}
        width="100%"
        height="100%"
        /* 這一層是 logo 的兄弟節點,min-width:auto 會讓它以內部跑馬燈的
           內容寬度為最小寬度,反過來把 logo 壓成 0 */
        minW={0}
      >
        <Flex
          alignItems={`center`}
          gap="55px"
          justifyContent={{
            base: "flex-end",
            xl: `space-between`,
          }}
          /* 同上:不解除 min-width:auto 的話,底下跑馬燈的內容寬度會一路往上
             撐出這一層,連帶把 logo 擠掉 */
          minW={0}
          //w="80%"
          w={{
            base: "100%",
            md: "100%",
            xl: "100%",
          }}
        >
          <Box
            as="section"
            flex={1}
            /* minW={0}:解除 flex item 預設的 min-width:auto。
               沒有這行,跑馬燈的內容長度會變成這個 Box 的最小寬度,
               擠壓到左邊 logo 與右邊按鈕群(內容越多擠得越兇,
               所以測試站假資料多時特別明顯,正式站反而看不出來)。
               overflow hidden 讓超出的字直接裁掉而不是往外推。 */
            minW={0}
            overflow="hidden"
            maxW={{
              base: "50%",
              xl: "70%",
              // 移除 "2xl": "100%":放寬到 100% 等於允許跑馬燈獨佔整列,
              // 右側機台按鈕就沒有空間了。
            }}
            display={{
              base: "none",
              lg: isMachineLandscape ? "none" : "block",
            }}
          >
            <MarqueeList />
          </Box>
          <Flex
            alignItems={"center"}
            /* 右側是餘額與機台按鈕(棄分 / NO. / 投注紀錄 / 重整 / 音樂 / 公告 / 語言),
               全是固定尺寸的圖片,壓不下去只會被推出畫面外 → 直接禁止收縮。 */
            flexShrink={0}
            gap={{
              base: "5px",
              sm: "10px",
            }}
          >
            <Box //電腦版
              display={{
                md: "flex",
                base: "none",
              }}
              gap={{
                md: "15px",
                base: "5px",
              }}
              alignItems={`center`}
            >
              {isLogin && <Balance />}
            </Box>
            {/* 手機版 */}
            <Flex
              alignItems={{
                base: "unset",
                md: "center",
              }}
              gap="5px"
            >
              <Flex alignItems="center" gap="5px">
                {/* <SignInDataV4 /> */}
                {!isMachineUser && ( //機台使用者不顯示
                  <Flex gap="5px" alignItems={"center"}>
                    {" "}
                    <Box
                      display={{
                        base: "none",
                        md: "block",
                      }}
                    >
                      <MusicToggleButton />
                    </Box>
                  </Flex>
                )}

                <Box
                  display={{
                    md: "none",
                    base: "flex",
                  }}
                  // mr={{
                  //   base: "130px",
                  //   sm: "130px",
                  //   xl: "150px",
                  // }}
                >
                  {isLogin && <Balance />}
                </Box>
                <Link to="profile/">
                  <Box
                    // w="24px"
                    // h="24px"
                    display={{
                      md: "none",
                      base: "flex",
                    }}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <Flex
                      color="light.100"
                      borderRadius={"100%"}
                      // bg="v3-second-brand.500"
                      alignItems={"center"}
                      justifyContent={"center"}
                      // w="50px"
                      // h="50px"
                    >
                      <Image
                        src={`${COMMON_WEB_PATH}/911TW/memberBTN.webp`}
                        w={{
                          base: "30px",
                          md: "50px",
                        }}
                        h={{
                          base: "30px",
                          md: "50px",
                        }}
                      />
                    </Flex>
                  </Box>
                </Link>
              </Flex>
              {/* <SignInDataV4 /> */}
              {!isMachineUser && ( //機台使用者不顯示
                <Flex
                  gap="5px"
                  alignItems={"center"}
                  display={{
                    base: "none",
                    md: "block",
                  }}
                >
                  <Link to={profilePath}>
                    <Box
                      position="relative"
                      cursor="pointer"
                      display="flex"
                      alignItems={"center"}
                      justifyContent={"center"}
                      shadow="sm"
                    >
                      <Image
                        src={`${COMMON_WEB_PATH}/911TW/memberBTN.webp`}
                        height={{
                          base: "50px",
                          xl: isMachineUser ? "70px" : "50px",
                        }}
                        minW={{
                          base: "50px",
                          xl: isMachineUser ? "70px" : "50px",
                        }}
                      />
                    </Box>
                  </Link>
                  {/* <Text
                    display={{
                      base: "none",
                      md: "block",
                    }}
                    fontWeight={700}
                  >
                    {memberInfo?.memId}
                  </Text> */}
                </Flex>
              )}
            </Flex>
            {/* <Flex gap="5px">
                  <Link to="signin">
                    <Box
                      initial={{ rotate: 0 }}
                      position="absolute"
                      top="0px"
                      right="0px"
                      cursor="pointer"
                      display="flex"
                      alignItems={"center"}
                      justifyContent={"center"}
                      shadow="sm"
                    >
                      <Image
                        src={`${COMMON_WEB_PATH}/FlyDragon/loginBTN.webp`}
                        height={{
                          base: "60px",
                          sm: "60px",
                          xl: "70px",
                        }}
                        width={{
                          base: "130px",
                          sm: "130px",
                          xl: "150px",
                        }}
                      />
                    </Box>
                  </Link>
                </Flex> */}
            {/* 未登入的機台用戶按鈕 */}
            {/* {!isLogin && isMachineUser && <MachineLoginButton />} */}
            {/* 只有機台用戶已登入時才顯示的棄分 重整按鈕 */}
            {isMachineUser && (
              <>
                {/* 棄分按鈕 */}
                <ClearCashRegisterButton />
                {isMachineUser && ( //非機台使用者不顯示
                  <Flex
                    //w="auto"
                    w={isMachineUser ? "160px" : "auto"}
                    minW="48px"
                    px="40px"
                    gap="8px"
                    height={{
                      base: "80px",
                      //xl: "85px",
                      xl: isMachineUser ? "110px" : "85px",
                    }}
                    bgImage={`url('${COMMON_WEB_PATH}/911TW/numberBG.webp')`}
                    bgPosition="center"
                    bgRepeat="no-repeat"
                    bgSize="100%100%"
                    alignItems={"center"}
                    justifyContent={"center"}
                    shadow="sm"
                    pt="10px"
                    pb="6px"
                  >
                    <Text
                      color="transparent"
                      sx={gradientStyle}
                      fontSize={{
                        base: "xl",
                        md: "2xl",
                        xl: isMachineUser ? "3xl" : "2xl",
                      }}
                      fontWeight="900"
                    >
                      NO.{memberInfo?.uid || "-"}
                    </Text>
                  </Flex>
                )}
                {/* 投注紀錄按鈕 */}
                <BetRecordButton />
                {/* 重整按鈕 */}
                <ReloadButton />
                {/* 音樂按鈕 */}
                <MusicToggleButton />
              </>
            )}

            {/* 公告按鈕 - 所有用戶都可見 */}
            <Box display={{ base: "none", sm: "flex" }} gap={"0.5em"}>
              <ReloadButton />
              <AnnouncementButton />
              <LanguageButton />
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Header;
